import {reactive} from "vue";

export const userStore = reactive({
	current: {}
});